import IconCopySolid from '@/assets/icons/font_awesome/copy-solid.svg?react';
import { use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { UI_PRIMITIVE__button_with_icon_animated } from '../../../components/ui/UI_PRIMITIVE__button_with_icon_animated';

interface Props {
  title: string;
  description: string;
  received_at: number;
  info: any;
}

export function ButtonCopyError({ title, description, received_at, info }: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { workspace_current } = use_slice_workspace(['current_workspace_user', 'workspace_current']);
  const { user_id } = use_slice_user(['user_id']);

  const { toast } = useToast();

  async function on_click() {
    const error_string = `
      error_title: ${title}\n
      error_description: ${description},\n
      received_at: ${received_at},\n
      client_workspace_id: ${workspace_current._id},\n
      client_user_id: ${user_id},\n
      ${Object.entries(info || {})
        .map(([key, value]) => `${key}: ${String(value)}`)
        .join(',\n')}`;

    await navigator.clipboard.writeText(error_string);

    toast({ title: t(i18n_base_ui.toasts.error_copy.title) });
  }

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      variant="no-border-on-bar"
      onClick={on_click}
      Icon={IconCopySolid}
      className="!p-o w-5 h-5"
      iconClassNameBase="w-5 h-5 text-component-item-foreground"
      iconClassNameHovered="!text-bar-foreground"
    />
  );
}
